export default class RequestBuilder {
  static LINE_BREAK = " \\\n" // Constant for line breaks

  constructor(url) {
    this.url = new URL(url) // Use the URL object for easier manipulation of query params
    this.method = "GET" // default method
    this.queryParams = {}
    this.headers = new Headers()
    this.cookies = new Map()
    this.body = null // for NON GET requests
  }

  // Set the HTTP method
  setMethod(method) {
    this.method = method.toUpperCase()
    return this
  }

  // Add a header
  setHeader(name, value) {
    this.headers.set(name, value)
    return this
  }

  // Delete a header
  deleteHeader(name) {
    this.headers.delete(name)
    return this
  }

  // Add a cookie
  addCookie(name, value) {
    this.cookies.set(name, `${name}=${value}`)
    return this
  }

  // Delete a cookie
  deleteCookie(name) {
    this.cookies.delete(name)
    return this
  }

  // Add a query parameter
  addQueryParam(name, value) {
    this.queryParams[name] = value
    return this
  }

  // Set the request body
  setBody(body) {
    this.body = body
    return this
  }

  unsetBody() {
    this.body = null
    return this
  }

  // Update the URL before sending the request
  updateUrl(newUrl) {
    this.url = new URL(newUrl)
    return this
  }

  // If there are cookies, append them to the headers
  buildCookies() {
    if(this.cookies.size > 0) {
      const cookies = Array.from(this.cookies.values()).join(" ")
      this.setHeader("Cookie", cookies)
    } else {
      this.deleteHeader("Cookie")
    }
  }

  // Build the request object
  build() {
    this.buildCookies()

    // Create the request options object
    Object.entries(this.queryParams).forEach(([k, v]) => this.url.searchParams.set(k, v))
    const requestOptions = {
      url: this.url,
      method: this.method,
      headers: this.headers
    }

    if (this.body) {
      if (this.headers.get("content-type") === "application/json") {
        requestOptions.body = JSON.stringify(this.body, null, 2)
      } else {
        requestOptions.body = new URLSearchParams(this.body).toString()
      }
    }

    // Create the request object
    return requestOptions
  }
}
